;(function() {
  "use strict";

  function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

  function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

  function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

  function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

  function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

  function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

  function _instanceof(left, right) { if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) { return !!right[Symbol.hasInstance](left); } else { return left instanceof right; } }

  function _classCallCheck(instance, Constructor) { if (!_instanceof(instance, Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

  function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

  var Popup = /*#__PURE__*/function () {
    function Popup(element) {
      _classCallCheck(this, Popup);

      if (typeof element === 'string' || _instanceof(element, String)) {
        this.container = document.querySelector(element);
      } else {
        this.container = element;
      }

      this.classes = {
        active: 'open'
      };
      this.closeBtns = _toConsumableArray(element.querySelectorAll('[data-close-popup]'));
      this.clickEvent = this.clickEvent.bind(this);
      this.keydownEvent = this.keydownEvent.bind(this);
      this.addEventListeners = this.addEventListeners.bind(this);
    }

    _createClass(Popup, [{
      key: "addEventListeners",
      value: function addEventListeners() {
        document.addEventListener('click', this.clickEvent);
        document.addEventListener('keydown', this.keydownEvent);
      }
    }, {
      key: "removeEventListeners",
      value: function removeEventListeners() {
        document.removeEventListener('click', this.clickEvent);
        document.removeEventListener('keydown', this.keydownEvent);
      }
    }, {
      key: "clickEvent",
      value: function clickEvent(event) {
        var _this = this;

        var anyCloseBtnsContainsTarget = function anyCloseBtnsContainsTarget() {
          var any = false;

          _this.closeBtns.forEach(function (btn) {
            if (btn.contains(event.target)) {
              any = true;
            }
          });

          return any;
        };

        if ( anyCloseBtnsContainsTarget() ) {
          event.stopPropagation();
          this.close();
        }

        // if (!this.container.contains(event.target) || anyCloseBtnsContainsTarget()) {
        //   event.stopPropagation();
        //   this.close();
        // }
      }
    }, {
      key: "keydownEvent",
      value: function keydownEvent(event) {
        if (event.key === 'Escape') {
          this.close();
        }
      }
    }, {
      key: "toggle",
      value: function toggle() {
        if (this.container.classList.contains(this.classes.active)) {
          this.close();
        } else {
          this.open();
        }
      }
    }, {
      key: "open",
      value: function open() {
        this.container.setAttribute('aria-hidden', 'false');
        this.container.classList.add(this.classes.active);
        document.documentElement.style.overflow = 'hidden';
        setTimeout(this.addEventListeners, 1);
      }
    }, {
      key: "close",
      value: function close() {
        this.container.setAttribute('aria-hidden', 'true');
        this.container.classList.remove(this.classes.active);
        document.documentElement.style.overflow = 'initial';
        this.removeEventListeners();
      }
    }]);

    return Popup;
  }();

  function initDraggable(container = null, popup = null) {
    const dragger = container.querySelector('[data-dragger]');

    const classes = {
      isDragging: 'is-dragging',
    };

    if (!dragger) {
      return;
    }

    const translateElement = window.theme.utils.throttle(10, (value) => {
      const translate = Math.max(0, value);

      container.style.transform = `translateY(${translate}px)`;
    });

    const getTouchesY = (event) => {
      const touches = [...event.touches];

      return touches.reduce((sum, touch) => sum + touch.clientY, 0) / touches.length;
    };

    let startY = null;
    let currentRelativeY = 0;
    dragger.addEventListener('touchstart', (event) => {
      container.classList.add(classes.isDragging);

      startY = getTouchesY(event);
    });

    dragger.addEventListener('touchmove', (event) => {
      event.preventDefault();

      const y = getTouchesY(event);
      currentRelativeY = y - startY;

      translateElement(currentRelativeY);
    });

    dragger.addEventListener('touchend', () => {
      container.classList.remove(classes.isDragging);

      const rect = container.getBoundingClientRect();
      container.style.transform = 'translateY(0)';

      if (currentRelativeY / rect.height >= 0.5) {
        popup.close();
      }
    });
  }


  // FYI: This code has been reworked to work with Geo.JS instead of IPGeolocation
  // There will still be mentions of ipgeolocation throughout the project, but it's only by name.
  // The code is not using the IPGeolocation API

  function renderFlag({ country_code: code }) {
    return String.raw`
      <img class="language-popup__item-icon" src="${window.theme.icons.assetUrl.replace('XXX', `flag-${code.toLowerCase()}`)}" loading="lazy">
    `;
  }

  function buildLangItem(language, checked = false) {
    let value = language.url;

    if (window.theme.ipgeolocation.keepPathname) {
      value += window.location.pathname.substr(1);
    }

    if (language.title.length <= 0) return "";

    return String.raw`
      <a class="language-popup__item" href="${value}?redirected=true">
        <div class="language-popup__item-inner">
          ${renderFlag(language)}
          <span>${language.title} (${language.country_code})</span>
        </div>
      </a>
    `
  }

  var langPopupNode = document.querySelector('[data-component="language-popup"]');
  if ( langPopupNode ) {
    var currIso2 = window?.theme?.ipgeolocation?.js?.current_iso ?? 'DK';
    var STLPopup = new Popup(langPopupNode);

    var initGeoPopup = function(countryCode) {
      var languagesData = window?.theme?.ipgeolocation?.js;
      const innerElement = langPopupNode.querySelector('[data-inner]');
      const recommended = langPopupNode.querySelector('[data-recommended]');
      const countryList = langPopupNode.querySelector('[data-country-list]');
      const closeBtn = langPopupNode.querySelector('[data-close-popup]');

      langPopupNode.addEventListener('click', (event) => {
        if (!innerElement.contains(event.target)) {
          STLPopup.close();
        }
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          STLPopup.close();
        });
      }

      // for testing without VPN
      // countryCode = 'US';

        if (countryCode !== currIso2) {
          if (languagesData.langs) {
            var fallbackLang = languagesData.langs.filter(function (lang) {
              return lang.country_code == "EU" || lang.country_code == "US";
            });
            var relatedLang = languagesData.langs.find(function (lang) {
              return lang.country_code === countryCode;
            });
            var suggestedLang = relatedLang ? relatedLang : fallbackLang[0];
            var queryString = window.location.search;
            var urlParams = new URLSearchParams(queryString);

            if (
              suggestedLang &&
              !urlParams.has("redirected") &&
              currIso2 !== suggestedLang.country_code
            ) {
              initDraggable(innerElement, STLPopup);
              STLPopup.open();

              if (recommended) {
                recommended.innerHTML = buildLangItem(suggestedLang, true);
              }

              if (countryList) {
                languagesData.langs.forEach((language) => {
                  countryList.innerHTML += buildLangItem(language);
                });
              }
            }
          }
        }
        if (countryList) {
          countryList.querySelectorAll("label").forEach(function (language) {
            language.addEventListener("click", function () {
              window.location.href = language.querySelector("input").value;
            });
          });
        }
    };

    var getLocation = function(callback) {
      fetch(`https://get.geojs.io/v1/ip/country.json`)
        .then(function(r) { return r.json() })
        .then(function(data) {
          var { country: countryCode } = data;
          var date = new Date();

          date.setFullYear(date.getFullYear() + 1);
          document.cookie = `geojs=true; path=/; expires=${date}`;

          callback(countryCode);
        })
        .catch(function(err) { return console.log(err) });
    };

    if (!document.cookie.includes('geojs=true')) {
      getLocation(initGeoPopup);
    }
  }
})();
